var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isMobile)?_c('MobileHeader'):_vm._e(),_c('Welcome'),(!_vm.isMobile)?_c('ContactBar'):_vm._e(),_c('WhatWeDo'),_c('Experience'),_c('Advantages'),_c('Contacts'),_c('Partners'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }